import React from 'react';
import FormikSearchDropdown from 'src/components/formik/FormikSearchDropdown/FormikSearchDropdown';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import PropTypes from 'prop-types';
import { companySearchAPI } from 'src/api/CompanyApi';

const CompanyDropDown = ({ value, name, ...rest }) => (
    <FormikSearchDropdown
        name={name}
        placeholder="Select Company"
        displayKeyPath={[
            'companyDisplayName',
        ]}
        valueKeyPath="_id"
        defaultValueFetchByKeyPath="_id"
        whereClauseKeysPaths={[
            'companyDisplayName',
        ]}
        api={companySearchAPI}
        apiCallAddonData={{
            pageLength: '',
        }}
        value={value}
        {...rest}
    />
);

CompanyDropDown.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    value: PropTypes.any,
    name: PropTypes.string.isRequired,
};

CompanyDropDown.defaultProps = { value: '' };

export default CompanyDropDown;
